<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              size="large"
              v-model="model.farm_id"
              v-bind:collapse-tags="true"
              :placeholder="`${$t('common_words.select')}...`"
              class="select-primary custom-width-select required-farm shadow-sm"
              @change="getLotByFarm()"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.allotment') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              size="large"
              v-model="model.lot_id"
              v-bind:collapse-tags="true"
              :placeholder="`${$t('common_words.select')}...`"
              class="select-primary custom-width-select required-lot shadow-sm"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              type="date"
              range-separator="-"
              v-model="model.date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              class="shadow-sm date-form required-date"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <br class="mb-1" />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validate"
            >
              {{ $t('common_words.continue') }}
            </button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  data() {
    return {
      model: {
        age: [],
        date: null,
        lot_id: null,
        farm_id: null,
        hasYoungPlants: false,
        sigatoka_config_id: null,
      },
      lots: [],
      farms: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    async validate() {
      if (!isset(this.model.farm_id))
        return this.validationInputsRequired('farm');
      if (!isset(this.model.lot_id))
        return this.validationInputsRequired('lot');
      if (!isset(this.model.date)) return this.validationInputsRequired('date');
      const hasConfig = await this.hasConfig();
      if (!hasConfig)
        return SweetAlert.warning(i18n.t('common_words.no_associated_config'));
      else this.goToCapture();
    },
    async hasConfig() {
      this.model.route = 'sigatoka/capture/config';
      const configRes = await Axios.postMasters(this.model);
      if (!configRes || !configRes.data.data) return false;
      const config = configRes.data.data;
      this.model.age = config.sigatoka_config_ages.map((a) => a.age);
      this.model.hasYoungPlants = config.young_plant;
      this.model.sigatoka_config_id = config.id;
      return true;
    },
    goToCapture() {
      if (this.isCreate() || this.isUpdate()) {
        this.showHideLoading(true);
        localStorage.setItem('model', JSON.stringify(this.model));
        this.$router.push(this.getModuleRoute + '/editcreate');
      } else this.showHideLoading();
    },
    getLotByFarm() {
      if (!isset(this.model.farm_id)) return;
      this.lots = [];
      this.farms.forEach((element) => {
        if (this.model.farm_id == element.id) {
          element.lots.forEach((item) => {
            this.lots.push(item);
          });
        }
      });
    },
  },
  computed: {
    getModuleRoute() {
      return 'capture';
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('farms/farms/only')])
        .then(([responseFarm]) => {
          this.farms = responseFarm.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
};
</script>
